import GADConfig from "../google-automated-discount";
import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const ngEuMerchant = "738826960";

const belgium: MarketConfiguration = {
  code: MarketEnum.be,
  label: "Belgium",
  descriptiveLabel: "Belgian",
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Belgium",
  locale: LocaleEnum.be,
  serviceLocale: ServiceLocaleEnum.be,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-be",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.be,
  adyenMarket: MarketEnum.be,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingThreshold: 100,
  freeShippingEnabled: false,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  googleAutomatedDiscounts: {
    allowedInTest: {
      allowedMerchants: new Set([ngEuMerchant, GADConfig.testMerchantId]),
      allowedPublicKeys: [
        GADConfig.testPublicKey,
        GADConfig.googleProductionPublicKey,
      ],
    },
    allowedInProd: {
      allowedMerchants: new Set([ngEuMerchant]),
      allowedPublicKeys: [GADConfig.googleProductionPublicKey],
    },
  },
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default belgium;
